import { IStoreLocator } from "../templates/StoreLocator/StoreLocator";

export const storeDetails: IStoreLocator["storeList"] = [
  {
    id: 1,
    title: "Intersport Store #1",
    distance: "3,4km away",
    address: "Westerstraat 210 , 7811 MZ Emmen",
    openingDetails: [
      {
        openingDates: "Mon - Fri",
        openingHours: "10:00 - 21:00",
      },
      {
        openingDates: "Sat",
        openingHours: "10:00 - 22:00",
      },
      {
        openingDates: "Sun",
        openingHours: "11:00 - 23:00",
      },
    ],
    phoneNumber: "+31612214182",
    quantity: 15,
    location: {
      lat: 52.3864001,
      lng: 4.8905659,
    },
    href: "/",
  },
  {
    id: 2,
    title: "Intersport Store #2",
    distance: "5,4km away",
    address: "Westerstraat 210 , 7811 MZ Emmen",
    openingDetails: [
      {
        openingDates: "Mon - Sun",
        openingHours: "10:00 - 21:00",
      },
    ],
    phoneNumber: "+31612214182",
    quantity: 7,
    location: {
      lat: 52.3736426,
      lng: 4.8990727,
    },
    href: "/",
  },
  {
    id: 3,
    title: "Intersport Store #3",
    distance: "6km away",
    address: "Westerstraat 210 , 7811 MZ Emmen",
    openingDetails: [
      {
        openingDates: "Mon - Sun",
        openingHours: "10:00 - 21:00",
      },
    ],
    phoneNumber: "+31612214182",
    quantity: 2,
    location: {
      lat: 52.3769664,
      lng: 4.89405,
    },
    href: "/",
  },
  {
    id: 4,
    title: "Intersport Store #4",
    distance: "15km away",
    address: "Westerstraat 210 , 7811 MZ Emmen",
    openingDetails: [
      {
        openingDates: "Mon - Sun",
        openingHours: "10:00 - 21:00",
      },
    ],
    phoneNumber: "+31612214182",
    quantity: 1,
    location: {
      lat: 52.0764369,
      lng: 5.081299,
    },
    href: "/",
  },
  {
    id: 5,
    title: "Intersport Store #5",
    distance: "25km away",
    address: "Westerstraat 210 , 7811 MZ Emmen",
    openingDetails: [
      {
        openingDates: "Mon - Sun",
        openingHours: "10:00 - 21:00",
      },
    ],
    phoneNumber: "+31612214182",
    quantity: 1,
    location: {
      lat: 52.0750884,
      lng: 4.3105336,
    },
    href: "/",
  },
  {
    id: 6,
    title: "Intersport Store #6",
    distance: "25km away",
    address: "Westerstraat 210 , 7811 MZ Emmen",
    openingDetails: [
      {
        openingDates: "Mon - Sun",
        openingHours: "10:00 - 21:00",
      },
    ],
    phoneNumber: "+31612214182",
    quantity: 0,
    location: {
      lat: 52.0670347,
      lng: 4.3392801,
    },
    href: "/",
  },
  {
    id: 7,
    title: "Intersport Store #7",
    distance: "25km away",
    address: "Westerstraat 210 , 7811 MZ Emmen",
    openingDetails: [
      {
        openingDates: "Mon - Sun",
        openingHours: "10:00 - 21:00",
      },
    ],
    phoneNumber: "+31612214182",
    quantity: 0,
    location: {
      lat: 51.9169806,
      lng: 4.4752697,
    },
    href: "/",
  },
  {
    id: 8,
    title: "Intersport Store #8",
    distance: "25km away",
    address: "Westerstraat 210 , 7811 MZ Emmen",
    openingDetails: [
      {
        openingDates: "Mon - Sun",
        openingHours: "10:00 - 21:00",
      },
    ],
    phoneNumber: "+31612214182",
    quantity: 0,
    location: {
      lat: 52.6320801,
      lng: 4.7395926,
    },
    href: "/",
  },
];

export const singleStoreDetails = {
  id: 0,
  title: "INTERSPORT TWINSPORT AMSTERDAM BUITENVELDERT",
  address: "Westerstraat 210 , 7811 MZ Emmen",
  openingDetails: [
    {
      openingDates: "Mon - Sun",
      openingHours: "10:00 - 21:00",
    },
  ],
  phoneNumber: "+31612214182",
  location: {
    lat: 52.3461952,
    lng: 4.8116789,
  },
  storeFeatures: [
    {
      id: 0,
      featureTitle: "SHOE RENTAL",
      featureDescription: "Rent our best models for your next adventure.",
    },
    {
      id: 1,
      featureTitle: "TEST & BUY",
      featureDescription: "Rent our best models for your next adventure.",
    },
    {
      id: 2,
      featureTitle: "SKI RENTAL",
      featureDescription: "Rent our best models for your next adventure.",
    },
    {
      id: 3,
      featureTitle: "DRY CLEANING",
      featureDescription: "Rent our best models for your next adventure.",
    },
    {
      id: 4,
      featureTitle: "EQUIPMENT CLEANING",
      featureDescription: "Rent our best models for your next adventure.",
    },
  ],
};

export const popularStoreList = [
  { id: 0, storeName: "BERLIN", href: "/" },
  { id: 2, storeName: "LUDWIGSHAFEN AM RHEIN", href: "/" },
  { id: 3, storeName: "COLOGNE", href: "/" },
  { id: 4, storeName: "FRANKFURT AM MAIN", href: "/" },
  { id: 4, storeName: "DORTMUND", href: "/" },
];

export const storeServicesFilter = [
  {
    id: "cb0",
    itemsCount: 25,
    title: "Foot Analysis",
  },
  {
    id: "cb1",
    itemsCount: 36,
    title: "Gift Card",
  },
  {
    id: "cb2",
    itemsCount: 17,
    title: "Shoe Rental",
  },
  {
    id: "cb3",
    itemsCount: 76,
    title: "Test & Buy",
  },
  {
    id: "cb4",
    itemsCount: 42,
    title: "Tailoring",
  },
  {
    id: "cb5",
    itemsCount: 18,
    title: "Black Diamond",
  },
  {
    id: "cb6",
    itemsCount: 30,
    title: "New Balance",
  },
  {
    id: "cb7",
    itemsCount: 98,
    title: "Nike",
  },
];
